import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { COMPANY_SELECTION } from '../Constants/Routes'

const AdminRoute = ({ companyStore, component: Component, ...rest }) => {
  const canAccess = () => {
    const company = companyStore.selectedCompany
    if (!company) return false
    if (!company.isThirdParty) return true
    return company.GuestRole === 'CompanyAdmin'
  }

  return (
    <Route
      {...rest}
      render={props =>
        canAccess() ? <Component {...props} /> : <Redirect to={COMPANY_SELECTION} />
      }
    />
  )
}

export default inject('companyStore')(observer(AdminRoute))
